module.exports = __webpack_public_path__ + "static/media/17.4bd94af2.jpg";